<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" size="small" :inline="true">
      <el-form-item label="接龙人姓名" prop="aliasName">
        <el-input
          v-model="queryParams.aliasName"
          placeholder="请输入接龙人姓名"
          clearable
          style="width: 240px"
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item label="是否收费" prop="isCharge">
        <el-select
          v-model="queryParams.isCharge"
          clearable
          placeholder="请选择"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="日期" prop="isCharge">
        <el-date-picker
          v-model="datetime"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          value-format="yyyy-MM-dd"
          format="yyyy-MM-dd"
          @change="change"
        >
        </el-date-picker>
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          icon="el-icon-search"
          size="mini"
          @click="handleQuery"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" size="mini" @click="resetQuery"
          >重置</el-button
        >
      </el-form-item>
    </el-form>
    <div class="table-header">
      <el-button
        type="success"
        style="margin-left: 10px"
        size="small"
        @click="exportSelectedData"
      >
        <i class="fa fa-level-down" aria-hidden="true"></i>
        导出选中数据
      </el-button>
    </div>
    <el-table
      v-loading="loading"
      :data="tableData"
      height="calc(100vh - 290px)"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
      :row-style="{ height: '58px' }"
      @selection-change="handleSelectionChange"
    >
      <!-- 多选框-->
      <el-table-column type="selection" align="center" width="55" fixed="left">
      </el-table-column>

      <el-table-column
        label="接龙人姓名"
        align="center"
        prop="aliasName"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <!-- <el-table-column
        label="是否计费"
        align="center"
        prop="isCharge"
        width="150"
        :show-overflow-tooltip="true"
      >
        <template slot-scope="scope">
          <span>{{ scope.row.isCharge == 1 ? "计费" : "不计费" }}</span>
        </template>
      </el-table-column> -->

      <!-- <el-table-column
        label="报餐次数"
        align="center"
        prop="sendDealNum"
        :show-overflow-tooltip="true"
      >
      </el-table-column> -->

      <el-table-column
        label="总用餐人数"
        align="center"
        prop="totalPeopleNum"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="总用餐次数"
        align="center"
        prop="totalDealNum"
        :show-overflow-tooltip="true"
      >
      </el-table-column>
      <el-table-column
        label="操作"
        align="center"
        width="160"
        class-name="small-padding fixed-width"
      >
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="text"
            icon="el-icon-edit"
            @click="handleExamine(scope.row)"
            >查看</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <pagination
      v-show="total > 0"
      :total="total"
      :pageSizes="[10, 30, 50, 100, 200]"
      :page.sync="queryParams.page"
      :limit.sync="queryParams.limit"
      @pagination="getList"
    />
    <el-drawer
      :visible.sync="drawer"
      :direction="direction"
      size="28%"
      :withHeader="false"
    >
      <div class="drawer-content">
        <div class="drawer-content-bottom">
          <h3>参与详情</h3>
          <ul v-if="useArry.length > 0">
            <li v-for="(item, index) in useArry" :key="index">
              <div class="drawer-content-bottom-left">
                <span class="drawer-content-index">{{ index + 1 }}</span>
                <span class="drawer-content-fz drawer-content-zhuti">{{
                  item.title
                }}</span>
                <span class="drawer-content-fz">{{ item.source }}</span>
                <!-- <img :src="item.headUrl" alt="" />
                <span class="drawer-content-fz">{{ item.aliasName }}</span> -->
              </div>
              <span class="drawer-content-fz">{{ item.signNum }}人</span>
              <span class="drawer-content-fz">{{
                formatDateTime(item.signTime)
              }}</span>
            </li>
          </ul>
          <el-empty description="未查询到数据" v-else></el-empty>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
    <script>
import table2excel from "js-table2excel/src";
import { reportTotalList, reportPerson } from "@/api/meal/MealTotal";
import moment from "moment";
export default {
  data() {
    return {
      tableData: [],
      direction: "rtl",
      drawer: false,
      // 总条数
      total: 0,
      // 遮罩层
      loading: false,
      // 非多个禁用
      multiple: true,
      // 是否显示弹出层
      open: false,
      // 表单参数
      form: {},
      options: [
        {
          value: 1,
          label: "计费",
        },
        {
          value: 0,
          label: "不计费",
        },
      ],
      datetime: [],
      useArry: [],
      selectedRows: [],
      fromParams: {
        flag: "",
        openId: "",
        startDate: "",
        endDate: "",
        limit: 9999,
        page: 1,
      },
      queryParams: {
        aliasName: "",
        isCharge: null,
        beginTime: "",
        endTime: "",
        limit: 10,
        page: 1,
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    formatDateTime(dateString) {
      return moment(dateString).format("YYYY-MM-DD HH:mm:ss"); // 自定义格式
    },
    /** 查询用户列表 */
    async getList() {
      this.loading = true;
      let { data, count } = await reportTotalList(this.queryParams);
      this.tableData = data;
      this.total = count;
      this.loading = false;
    },
    change(e) {
      if (e) {
        this.queryParams.beginTime = e[0];
        this.queryParams.endTime = e[1];
      } else {
        this.queryParams.beginTime = "";
        this.queryParams.endTime = "";
      }
    },
    //选择
    handleSelectionChange(val) {
      this.selectedRows = val;
    },
    /** 查看按钮操作 */
    async handleExamine(e) {
      if (this.queryParams.endTime == "" || this.queryParams.beginTime == "") {
        this.$message({
          message: "请先选择查询日期范围",
          type: "warning",
        });
        return;
      }
      this.fromParams.flag =
        this.queryParams.isCharge == null ? "" : !!this.queryParams.isCharge;
      this.fromParams.startDate = this.datetime[0];
      this.fromParams.endDate = this.datetime[1];
      this.fromParams.openId = e.openid;
      let { data } = await reportPerson(this.fromParams);
      this.useArry = data;
      this.drawer = true;
    },
    // 提取列标题映射逻辑到单独的方法
    getColumnTitle(key) {
      const mapping = {
        aliasName: "接龙人姓名",
        totalPeopleNum: "总用餐人数",
        totalDealNum: "总用餐次数",
        signTime: "接龙时间",
      };
      return mapping[key];
    },
    //导出选中数据
    async exportSelectedData() {
      const columns = [
        "aliasName",
        "totalPeopleNum",
        "totalDealNum",
        'signTime'
      ];
      const columnConfig = columns.map((key) => ({
        title: this.getColumnTitle(key),
        key,
        type: "text",
        width: 150,
        height: 100,
        wrapText: true, // 设置单元格可以换行
      }));
      const rowsToExport = this.tableData
        .filter((row, index) => this.selectedRows[index])
        .map((ele) => ({
          ...ele,
          signTime: this.splitString(ele.signTime).join("\n"),
        }));
      const excelName = "报餐接龙统计表.xlsx";
      table2excel(columnConfig, rowsToExport, excelName);
    },
    //字符串分割换行
    splitString(str) {
      return str.split(",").map((line) => line.trim());
    },
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          done();
        })
        .catch((_) => {});
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.page = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.queryParams = {
        aliasName: "",
        isCharge: null,
        beginTime: "",
        endTime: "",
        limit: 10,
        page: 1,
      };
      this.datetime = [];
      this.getList();
    },
  },
};
</script>
    
<style scoped lang="scss">
.drawer-content {
  margin-top: 20px;
  padding: 0 10px 0 30px;
}
.drawer-content-middle p {
  padding: 0;
  margin: 5px 0;
}
.drawer-content-bottom h3 {
  text-align: center;
  border-bottom: 1px solid pink;
  padding-bottom: 10px;
}
.drawer-content-bottom ul {
  padding: 0;
  height: 800px;
  overflow: auto;
}
.drawer-content-bottom ul li {
  list-style: none;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid pink;
  padding: 8px 10px;
}
.drawer-content-bottom-left {
  display: flex;
  align-items: center;
  width: 280px;
}
.drawer-content-bottom-left img {
  width: 40px;
  height: 40px;
  display: inline-block;
  border-radius: 50%;
  margin: 0 20px;
}
.drawer-content-zhuti {
  width: 180px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.drawer-content-index {
  margin-right: 20px;
  font-size: $font-size-base;
  color: #999;
  width: 20px;
}
.drawer-content-fz {
  font-size: $font-size-base;
}

::v-deep .el-form--inline .el-form-item__label {
  font-weight: 600;
}
.table-header {
  display: flex;
  justify-content: end;
  margin-bottom: 10px;
}
</style>
<style lang="scss" scoped>
::v-deep .el-drawer__header {
  margin-bottom: 0;
}
::v-deep .el-drawer__body {
  padding: 0;
}

.drawer-content-fz {
  font-size: $font-size-base;
}
.demo-table-expand {
  font-size: 0;
  padding: 0 50px;
}
.demo-table-expand label {
  width: 90px;
  color: #99a9bf;
}
::v-deep .el-form--inline .el-form-item__label {
  font-weight: 600;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>